// Diet helpers: a dish's base diet as two booleans, with each variant's effective diet derived from its add-ons.

// Resolve a dish-like object ({ is_vegetarian, is_vegan }) to a diet token.
export function dietOf(dishLike) {
  if (!dishLike) return 'veg';
  if (dishLike.is_vegan) return 'vegan';
  if (dishLike.is_vegetarian) return 'veg';
  return 'nonveg';
}

// The effective diet of a single variant, from the dish's base diet and the diets of its add-ons.
export function effectiveVariantDiet(dishDiet, addonDiets = []) {
  // A non-veg dish is non-veg everywhere; add-ons never change it.
  if (dishDiet === 'nonveg') return 'nonveg';
  // Any non-veg add-on escalates a veg/vegan variant to non-veg.
  if (addonDiets.some((d) => d === 'nonveg')) return 'nonveg';
  // A vegan dish stays vegan only while every add-on is also vegan.
  if (dishDiet === 'vegan') {
    return addonDiets.some((d) => d !== 'vegan') ? 'veg' : 'vegan';
  }
  return 'veg';
}

// Presentation metadata for a diet token, so badges and dots look identical on every screen.
export const DIET_META = {
  veg: {
    label: 'Veg',
    dot: 'bg-green-500',
    badge: 'border-green-400 bg-green-50 text-green-700',
  },
  nonveg: {
    label: 'Non-Veg',
    dot: 'bg-rose-600',
    badge: 'border-rose-500 bg-rose-50 text-rose-800',
  },
  vegan: {
    label: 'Vegan',
    dot: 'bg-emerald-800',
    badge: 'border-emerald-700 bg-emerald-50 text-emerald-900',
  },
};

export function dietMeta(diet) {
  return DIET_META[diet] || DIET_META.veg;
}
